<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Position"
      text="Edit Position"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localPosition.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="localPosition.job_grade_id"
                v-validate="'required'"
                :items="jobGrades"
                label="Job Grade"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('job_grade_id')"
                data-vv-name="job_grade_id"
                data-vv-as="job grade"
              />
              <!-- <v-autocomplete 
                v-model="localPosition.position_group_id"
                v-validate="'required'"
                :items="positionGroups"
                label="Position Group"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('position_group_id')"
                data-vv-name="position_group_id"
                data-vv-as="position group"
              /> -->
            </v-col>

            <!--<v-col cols="12">
              <v-autocomplete 
                v-model="localPosition.position_category_id"
                v-validate="'required'"
                label="Position Category"
                :items="positionCategories"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('positionCategory')"
                data-vv-name="positionCategory"
                data-vv-as="position category"
              />
            </v-col> -->

            <!-- <v-col cols="12">
              <v-row no-gutters>
                <v-col
                  cols="2"
                  class="ma-auto"
                >
                  <span style="font-size:16px">
                    Rank From
                  </span>
                </v-col>

                <v-col>
                  <v-autocomplete
                    v-model="localPosition.rank_from_id"
                    :items="filteredRanks"
                    item-text="pivot.name"
                    item-value="pivot.id"
                    hide-no-data
                    hide-selected
                  >
                    <template v-slot:selection="data">
                      <v-chip :input-value="data.selected">
                        <v-avatar
                          rounded
                          left
                        >
                          <img :src="data.item.image_url">
                        </v-avatar>
                        {{ data.item.pivot.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-avatar tile>
                          <img :src="data.item.image_url">
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.pivot.name" />
                          <v-list-item-subtitle> {{ `Rank ${data.item.value}` }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col
                  class="ma-auto"
                  cols="1"
                >
                  <span style="font-size:16px;margin-left:12px">
                    To
                  </span>
                </v-col>

                <v-col>
                  <v-autocomplete
                    v-model="localPosition.rank_to_id"
                    :items="ranksTo"
                    item-text="pivot.name"
                    item-value="pivot.id"
                    hide-no-data
                    hide-selected
                  >
                    <template v-slot:selection="data">
                      <v-chip :input-value="data.selected">
                        <v-avatar
                          rounded
                          left
                        >
                          <img :src="data.item.image_url">
                        </v-avatar>
                        {{ data.item.pivot.name }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-avatar tile>
                          <img :src="data.item.image_url">
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.pivot.name" />
                          <v-list-item-subtitle> {{ `Rank ${data.item.value}` }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col> -->
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      position: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        // categories: [],
        localPosition: null,
        // positionGroups: [],
        jobGrades: [],
      }
    },
    // computed: {
    //   positionCategories () {
    //     if (!this.localPosition.position_group_id || this.positionGroups.length < 1) return 

    //     return this.positionGroups.find(item => { return item.id === this.localPosition.position_group_id }).position_categories
    //   },

    //   filteredRanks () {
    //     if (!this.localPosition.position_category_id || !this.positionCategories) return
  
    //     return ((this.positionCategories.find(item => item.pivot.position_category_id === this.localPosition.position_category_id) || {}).ranks) || []
    //   },

    //   ranksTo () {
    //     if (!this.localPosition.rank_from_id || !this.positionCategories || this.filteredRanks.length < 0) return 

    //     return this.filteredRanks.filter(item => { return item.pivot.id >= this.localPosition.rank_from_id })
    //   },
    // },
    watch: {
      dialog: function (value) {
        if (value) {
          // this.loadPositionGroups()
          this.loadJobGrades()
          this.localPosition = { ...this.position }
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.positions().update(this.position.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localPosition.name,
          job_grade_id: this.localPosition.job_grade_id,
          // position_group_id: this.localPosition.position_group_id,
          // rank_from_id: this.localPosition.rank_from_id,
          // rank_to_id: this.localPosition.rank_to_id,
          // position_category_id: this.localPosition.position_category_id,
        }
      },
      loadJobGrades () {
        this.$api.jobGrades().list()
          .then(res => {
            this.jobGrades = res.data
          })
      },
      // loadPositionGroups () {
      //   this.$api.positionGroups().list()
      //     .then(res => {
      //       this.positionGroups = res.data
      //     })
      // },
    },
  }
</script>
